module.exports = __webpack_public_path__ + "static/12invgde-91a6f8cbc0cbe71d7abb113b3f4311cb.gif";